const YOUTUBE_HOSTS = new Set([
  "youtube.com", "www.youtube.com", "m.youtube.com",
  "youtube-nocookie.com", "www.youtube-nocookie.com", "music.youtube.com", "youtu.be", "www.youtu.be",
]);

// Aceita somente links do YouTube. Uma playlist não identifica o autor do vídeo.
export function youtubeSource(value) {
  let url;
  try {
    const source = String(value || "").trim();
    url = new URL(source.startsWith("//") ? `https:${source}` : source);
  } catch {
    return null;
  }
  if (!/^https?:$/.test(url.protocol) || !YOUTUBE_HOSTS.has(url.hostname) || url.username || url.password)
    return null;
  const parts = url.pathname.split("/").filter(Boolean);
  const id = ["youtu.be", "www.youtu.be"].includes(url.hostname)
    ? parts[0]
    : ["embed", "shorts", "live", "v"].includes(parts[0])
      ? parts[1]
      : url.searchParams.get("v");
  const videoId = id !== "videoseries" && /^[a-zA-Z0-9_-]{11}$/.test(id || "") ? id : null;
  const link = new URL(videoId ? "https://www.youtube.com/watch" : "https://www.youtube.com/playlist");
  if (videoId) link.searchParams.set("v", videoId);
  const list = url.searchParams.get("list");
  if (/^[a-zA-Z0-9_-]{10,100}$/.test(list || "")) link.searchParams.set("list", list);
  const time = url.searchParams.get("start") || url.searchParams.get("t");
  if (videoId && /^(?:\d+h)?(?:\d+m)?\d+s?$/.test(time || "")) link.searchParams.set("t", time);
  return { videoId, url: link.searchParams.toString() ? link.href : "https://www.youtube.com/" };
}

// Uma playlist pode misturar canais. O player próprio mostra apenas o vídeo
// confirmado e recomenda, ao terminar, vídeos do mesmo canal.
export function ownedYoutubeEmbed(value) {
  const video = youtubeSource(value);
  if (!video?.videoId) return value;
  const original = new URL(value.startsWith("//") ? `https:${value}` : value);
  const url = new URL(`https://www.youtube.com/embed/${video.videoId}`);
  const start = original.searchParams.get("start");
  if (/^\d+$/.test(start || "")) url.searchParams.set("start", start);
  url.searchParams.set("rel", "0");
  return url.href;
}
